import { _ConstructionType, _TagClassType, _UniversalType } from '../asn1/enumerator';
import { _PdfAbstractSyntaxElement } from '../asn1/abstract-syntax';
import { _PdfUniqueEncodingElement } from '../asn1/unique-encoding-element';
import { _PdfObjectIdentifier } from '../asn1/identifier-mapping';
var _PdfAlgorithms = /** @class */ (function () {
    function _PdfAlgorithms(element) {
        if (element) {
            this._element = element;
            var list = element._getSequence();
            if (!list || list.length < 1 || list.length > 2) {
                throw new Error('Invalid Algorithm Identifier sequence length');
            }
            var oidElement = list[0];
            var oidBytes = oidElement._getValue();
            this._objectID = new _PdfObjectIdentifier()._fromBytes(oidBytes);
            if (list.length === 2) {
                this._parameters = list[1];
                this._parametersDefined = true;
            }
            else {
                this._parametersDefined = false;
            }
        }
    }
    _PdfAlgorithms.prototype._getAlgorithms = function (obj) {
        if (obj instanceof _PdfAlgorithms) {
            return obj;
        }
        if (obj instanceof _PdfAbstractSyntaxElement) {
            return new _PdfAlgorithms(obj);
        }
        return undefined;
    };
    _PdfAlgorithms.prototype._uniqueEncoderEncode = function () {
        if (this._element) {
            return this._element._getValue(); // eslint-disable-line
        }
        throw new Error('Cannot DER encode: not a DER element');
    };
    _PdfAlgorithms.prototype._getUniqueEncoderNull = function () {
        var derNull = new _PdfUniqueEncodingElement();
        derNull._setTagNumber(5);
        derNull._tagClass = 0;
        derNull._setValue(new Uint8Array(0));
        return derNull;
    };
    _PdfAlgorithms.prototype._getAbstractSyntax = function () {
        var seq = new _PdfUniqueEncodingElement(_TagClassType.universal, _ConstructionType.constructed, _UniversalType.sequence);
        var oidElement = new _PdfUniqueEncodingElement(_TagClassType.universal, _ConstructionType.primitive, 6);
        var elements = [oidElement];
        seq._setSequence(elements);
        return seq;
    };
    return _PdfAlgorithms;
}());
export { _PdfAlgorithms };
